import React from "react";

const defaults: any = {};

const FormContext = React.createContext(defaults);

export default FormContext;
